import {
  Avatar
} from '@mui/material';
import React from 'react';
import {getUserProfile} from '../../../../core/PermissionHandler';

function HeaderUserbox() {
  const profile = getUserProfile();
  let email = profile?.email || null; 
  function stringAvatar(name) {
    return { 
      children: `${name.charAt(0).toLocaleUpperCase()}`,
    };
  }
  
  return (
    <>  {
      email!=null && 
      <><Avatar {...stringAvatar(email)}  sx={{ width: 32, height: 32 }}/>  &nbsp; {email}</>
    }
    </>
  );
}

export default HeaderUserbox;
